import { render, staticRenderFns } from "./ProductGalleryZoomCarousel.vue?vue&type=template&id=670b5f04&scoped=true"
import script from "./ProductGalleryZoomCarousel.vue?vue&type=script&lang=js"
export * from "./ProductGalleryZoomCarousel.vue?vue&type=script&lang=js"
import style0 from "./ProductGalleryZoomCarousel.vue?vue&type=style&index=0&id=670b5f04&prod&lang=scss&scoped=true"
import style1 from "./ProductGalleryZoomCarousel.vue?vue&type=style&index=1&id=670b5f04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670b5f04",
  null
  
)

export default component.exports